import SalesUncategorizedTable from './SalesUncategorizedTable';

export default SalesUncategorizedTable;
